import * as Joi from "joi";
import { PrimaryGeneratedColumn } from 'typeorm';

export default abstract class Base {
	static readonly skipUpdateColumns = ['id'];

	@PrimaryGeneratedColumn()
	id: number;

	mobile_id: string;

	static rules() {
		return {
			id: Joi.number().integer().allow(null),
		};
	}

	clone() {
		return new (<any>this.constructor)(this); // tslint:disable-line
	}

	cloneAndAssign(props?: Partial<any>) {
		// tslint:disable-line:no-any
		const clone = this.clone();
		clone.assign(props);
		return clone;
	}

	assign(props?: Partial<Base>) {
		Object.assign(this, props.toJSON ? props.toJSON() : props);

		if (props.mobile_id === '') {
			this.mobile_id = null;
		}
	}

	constructor(props?: Partial<Base>) {
		if (!props) {
			return;
		}
		this.assign(props);
	}

	toJSON() {
		return {
			id: this.id,
		};
	}

	isNew(): boolean {
		return !this.id;
	}
}
